import { useMediaQuery, BREAKPOINTS } from "@tellescope/ui";
import { useIsSidebarNavigationEnabled } from "../../shared/store/portalSchemaStore";

/**
 * Hook to determine if the sidebar should be displayed.
 * Returns true only when:
 * 1. The setting enableSidebarNavigation is true
 * 2. The screen width is >= 1024px (lg breakpoint)
 */
export function useSidebarEnabled(): boolean {
  const isSettingEnabled = useIsSidebarNavigationEnabled();
  const isLargeScreen = useMediaQuery(`(min-width: ${BREAKPOINTS.lg}px)`);

  return isSettingEnabled && isLargeScreen;
}
